// API_BASE_URL resolves at build time from REACT_APP_API_BASE_URL.
// The hosted backend fallback prevents accidental requests to localhost or the
// frontend host when the CRA env value is missing.
const DEFAULT_API_BASE_URL = "https://callapi.nexoraaitech.com";
export const API_BASE_URL =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_API_BASE_URL) ||
  DEFAULT_API_BASE_URL;
export const REFRESH_MS = 100;
export const PAGE_SIZE = 10;
export const TEAM_PAGE_SIZE = 10;

export const APP_TABS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "analytics", label: "Analytics" },
  { id: "leads", label: "Lead Management" },
  { id: "appointments", label: "Appointments" },
  { id: "campaigns", label: "Campaigns" },
];

export const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", to: "/dashboard", icon: "dashboard" },
  { id: "calls", label: "Calls", to: "/calls", icon: "calls" },
  { id: "analytics", label: "Analytics", to: "/analytics", icon: "analytics" },
  {
    id: "lead-management",
    label: "Contacts / Leads",
    to: "/lead-management",
    icon: "leads",
  },
  {
    id: "appointments",
    label: "Appointments",
    to: "/appointments",
    icon: "appointments",
  },
  { id: "campaigns", label: "Campaigns", to: "/campaigns", icon: "campaigns" },
  {
    id: "team-management",
    label: "Team Management",
    to: "/team-management",
    icon: "team",
  },
  {
    id: "settings",
    label: "Settings",
    to: "/settings",
    icon: "settings",
  },
];

// Add this new export (keep all your existing exports)


export const NAV_SECTIONS = [
  {
    title: "Workspace",
    items: [
      {
        id: "dashboard",
        label: "Dashboard",
        to: "/dashboard",
        icon: "dashboard",
      },
      { id: "calls", label: "Calls", to: "/calls", icon: "calls" },
      {
        id: "analytics",
        label: "Analytics",
        to: "/analytics",
        icon: "analytics",
      },
      {
        id: "appointments",
        label: "Appointments",
        to: "/appointments",
        icon: "appointments",
      },
    ],
  },
  {
    title: "Operations",
    items: [
      {
        id: "lead-management",
        label: "Contacts / Leads",
        to: "/lead-management",
        icon: "leads",
      },
      {
        id: "campaigns",
        label: "Campaigns",
        to: "/campaigns",
        icon: "campaigns",
      },
      {
        id: "team-management",
        label: "Team Management",
        to: "/team-management",
        icon: "team",
      },
    ],
  },
  {
    title: "Settings",
    items: [
      { id: "settings", label: "Settings", to: "/settings", icon: "settings" },
    ],
  },
];

export const ROLE_PAGE_ACCESS = {
  admin: [
    "dashboard",
    "calls",
    "analytics",
    "appointments",
    "lead-management",
    "campaigns",
    "team-management",
    "settings",
  ],
  calling_agent: [
    "dashboard",
    "calls",
    "appointments",
    "lead-management",
  ],
};
export const TEAM_ROLE_OPTIONS = [
  "AI Calling Agent",
  "Senior Agent",
  "Team Lead",
  "Supervisor",
  "Operations Manager",
  "Quality Analyst",
  "Campaign Coordinator",
  "Appointment Coordinator",
  "Lead Follow-up Specialist",
];

export const TEAM_NAME_OPTIONS = [
  "Botox Team",
  "Fillers Team",
  "Follow-up Team",
  "Campaign Team",
];

export const TEAM_SHIFT_OPTIONS = ["Morning", "Afternoon", "Evening"];

export const TEAM_STATUS_OPTIONS = ["Active", "Break", "Offline", "In Call"];

export const CALL_STATUS_FILTERS = [
  { value: "", label: "All" },
  { value: "booked", label: "Booked" },
  { value: "dropped", label: "Dropped" },
  { value: "info", label: "Info" },
];

export const CALL_FOLLOW_UP_STATUS_OPTIONS = [
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "callback_required", label: "Callback Required" },
  { value: "no_answer", label: "No Answer" },
  { value: "not_interested", label: "Not Interested" },
  { value: "booked", label: "Booked" },
  { value: "failed", label: "Failed" },
];

export const CALL_DISPOSITION_OPTIONS = [
  { value: "booked", label: "Booked" },
  { value: "interested", label: "Interested" },
  { value: "not_interested", label: "Not Interested" },
  { value: "callback_required", label: "Callback Required" },
  { value: "no_answer", label: "No Answer" },
  { value: "wrong_number", label: "Wrong Number" },
  { value: "do_not_call", label: "Do Not Call" },
  { value: "follow_up_needed", label: "Follow Up Needed" },
];

export const QUEUE_TASK_FILTERS = [
  { value: "", label: "All" },
  { value: "confirm_appointment", label: "Confirm" },
  { value: "call_back_at_time", label: "Callback" },
  { value: "interested", label: "Interested" },
  { value: "follow_up", label: "Follow Up" },
];

export const LEAD_TASK_FILTERS = [
  { value: "", label: "All" },
  { value: "confirm_appointment", label: "Confirm" },
  { value: "call_back_at_time", label: "Callback" },
  { value: "interested", label: "Interested" },
  { value: "follow_up", label: "Follow Up" },
];

export const TASK_PRIORITY = {
  confirm_appointment: 0,
  call_back_at_time: 1,
  interested: 2,
  follow_up: 3,
};

export const TASK_LABELS = {
  confirm_appointment: "Confirm",
  call_back_at_time: "Callback",
  interested: "Interested",
  follow_up: "Follow Up",
};

export const TASK_CLASSES = {
  confirm_appointment: "task-confirm",
  call_back_at_time: "task-callback",
  interested: "task-interested",
  follow_up: "task-followup",
};

export const APPOINTMENT_STATUS_OPTIONS = [
  { value: "all", label: "All Statuses" },
  { value: "requested", label: "Requested" },
  { value: "booked", label: "Confirmed" },
  { value: "cancelled", label: "Cancelled" },
];

export const APPOINTMENT_SERVICE_OPTIONS = [
  ["clinic", "Clinic Consultation"],
  ["aesthetics", "Aesthetics"],
  ["weightloss_slimming", "Weightloss & Slimming"],
  ["iv_drip", "IV Drip"],
  ["laser_hair_removal", "Laser Hair Removal"],
  ["dental", "Dental"],
  ["physiotherapy", "Physiotherapy"],
  ["urology", "Urology"],
  ["home_care", "Homecare"],
  ["lab_tests", "Lab Tests"],
];

export const CAMPAIGN_TARGET_TYPES = [
  { value: "all", label: "All Patients (from call history)" },
  { value: "lead_cache", label: "Lead Cache (callable leads)" },
  { value: "service", label: "By Service Interest" },
  { value: "lead_status", label: "By Lead Status" },
  { value: "custom", label: "Custom List (paste or upload)" },
];
